export default {
  styleOverrides: {
    root: {
      borderRadius: '4px',
    },
  },
};
